/**
 * Pick the snap target for a fling: project along velocity, then nearest stop.
 * Allocation-free scan (journey rulers are ~100–200 stops).
 * Always returns an exact stop so the ruler settles on a full integer value.
 * @worklet
 */
export const snapPoint = (
  value: number,
  velocity: number,
  points: ReadonlyArray<number>,
): number => {
  'worklet';
  const n = points.length;
  if (n === 0) {
    return value;
  }
  if (n === 1) {
    return points[0]!;
  }

  const speed = Math.abs(velocity);
  /**
   * Velocity projection tuned for a longer, premium coast without skipping past
   * the intended neighborhood on short flicks.
   */
  const projection =
    speed > 2800 ? 0.42 : speed > 1600 ? 0.3 : speed > 900 ? 0.2 : speed > 400 ? 0.12 : 0.045;
  const projected = value + projection * velocity;

  let best = points[0]!;
  let best_delta = Math.abs(projected - best);
  for (let i = 1; i < n; i++) {
    const p = points[i]!;
    const d = Math.abs(projected - p);
    if (d < best_delta) {
      best = p;
      best_delta = d;
    }
  }
  return best;
};
